




































import { Component, Prop, Vue } from 'vue-property-decorator';

import AuthMenu from '@/componentsV2/molecules/AuthMenu/AuthMenu.vue';
import ActionSheetMenu from '@/componentsV2/organisms/ActionSheetMenu/ActionSheetMenu.vue';

import NotificationMenu from '@/componentsV2/molecules/NotificationMenu/NotificationMenu.vue';
import flagKeys from '@/constants/flagKeys';

import SearchBar from '../SearchBar/SearchBar.vue';

import TopBarNavItem from './TopBarNavItem.vue';
import HumburguerIcon from '@/components/icons/Humburguer.vue';
import eventBus from '@/utils/eventBus';

type BreakpointInfo = {
  items: number;
};

enum EBreakpoints {
  DESKTOP = 1280,
  MEDIUM_DESKTOP = 1180,
  SMALL_DESKTOP = 1050,
  TABLET = 854,
  MOBILE = 645
}

@Component<TopBar>({
  components: {
    TopBarNavItem,
    AuthMenu,
    ActionSheetMenu,
    NotificationMenu,
    SearchBar,
    HumburguerIcon
  }
})
export default class TopBar extends Vue {
  @Prop() notificationMenu?: any;
  moreMenuOpened = false;

  get configByBreakpoints(): Record<EBreakpoints, BreakpointInfo> {
    return {
      [EBreakpoints.DESKTOP]: {
        items: 5
      },
      [EBreakpoints.MEDIUM_DESKTOP]: {
        items: 4
      },
      [EBreakpoints.SMALL_DESKTOP]: {
        items: 3
      },
      [EBreakpoints.TABLET]: {
        items: 2
      },
      [EBreakpoints.MOBILE]: {
        items: 1
      }
    };
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get isSearchBar() {
    return (
      this.flags.includes(flagKeys.newSearchBar) &&
      !this.isMobileDevice &&
      !this.isSuperAdmin
    );
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isSuperAdmin() {
    return this.$store.getters['business/isRootView'];
  }

  get enabledNotification() {
    return (
      this.flags.includes(flagKeys.notificationCenter) && !this.isSuperAdmin
    );
  }

  openLeftBar() {
    eventBus.$emit('toggleAuthTopBarMobile', false);
    eventBus.$emit('toggleLeftBarMobile', true);
  }
}
